import { useSelector } from 'react-redux';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Typography } from '@components/Typography';
import Tooltip from '@components/Tooltip';
import { getChannelIcon } from '@helpers/channels';
import { CHANNEL_NAME, CHANNEL } from '@constants/channels';
import { AccIntegrationName } from '@constants/integrations';
import { isIntegrationConnected } from '@helpers/integrations';
import { useTranslation } from '@hooks';
import { StyledRadioGroup, Container, ChannelRadioWrapper } from './styles';

const SelectChannel = ({ modal, setModal }) => {
    const { t } = useTranslation();
    const account = useSelector(state => state.account?.account);

    const isFacebookConnected = isIntegrationConnected(account, AccIntegrationName.Facebook);
    const isWhatsAppConnected = isIntegrationConnected(account, AccIntegrationName.WhatsApp);

    return (
        <Container>
            {[
                { name: CHANNEL_NAME.SMS, id: CHANNEL.SMS, isConnected: true },
                { name: CHANNEL_NAME.EMAIL, id: CHANNEL.EMAIL, isConnected: true },
                { name: CHANNEL_NAME.WHATSAPP, id: CHANNEL.WHATSAPP, isConnected: true },
                {
                    name: CHANNEL_NAME.WHATSAPP_BUSINESS,
                    id: CHANNEL.WHATSAPP_BUSINESS,
                    isConnected: isWhatsAppConnected,
                    disabledTooltip: t('SettingsCompanies.whatsappAccountRequired'),
                },
                { name: CHANNEL_NAME.LIVE_CHAT, id: CHANNEL.LIVE_CHAT, isConnected: true },
                {
                    name: CHANNEL_NAME.FACEBOOK,
                    id: CHANNEL.FACEBOOK,
                    isConnected: isFacebookConnected,
                    disabledTooltip: t('SettingsCompanies.facebookAccountRequired'),
                },
                {
                    name: CHANNEL_NAME.INSTAGRAM,
                    id: CHANNEL.INSTAGRAM,
                    isConnected: isFacebookConnected,
                    disabledTooltip: t('SettingsCompanies.facebookAccountRequired'),
                },
            ].map(channel => {
                const channelRow = (
                    <ChannelRadioWrapper
                        key={channel.id}
                        isActive={Number(modal.type) === channel.id}
                        isDisabled={!channel.isConnected}
                        onClick={() => channel.isConnected && setModal(prev => ({ ...prev, type: channel.id }))}
                    >
                        <StyledRadioGroup value={`${modal.type}`}>
                            <FormControlLabel
                                value={channel.isConnected ? `${channel.id}` : 'disabled'}
                                control={
                                    <Radio
                                        sx={{
                                            color: 'var(--text-secondary)',
                                            padding: '6px',
                                            '&.Mui-checked': { color: 'var(--primary-main)' },
                                        }}
                                        disabled={!channel.isConnected}
                                    />
                                }
                                label=""
                                disabled={!channel.isConnected}
                            />
                            {getChannelIcon(channel.id)}
                            <Typography variant="body2" sx={{ marginLeft: '10px' }}>
                                {channel.name}
                            </Typography>
                        </StyledRadioGroup>
                    </ChannelRadioWrapper>
                );

                return !channel.isConnected && channel.disabledTooltip ? (
                    <Tooltip key={channel.id} title={channel.disabledTooltip} placement="top" enterTouchDelay={0}>
                        {channelRow}
                    </Tooltip>
                ) : (
                    channelRow
                );
            })}
        </Container>
    );
};

export default SelectChannel;
